export class DriverLicenseVm{
    Id: number = 0;
    Number: string = "";
    IssuingAuthority: string = "";
    ValidFrom: Date | null = null;
    ValidTo: Date | null = null;
    BStatus: string = "";
    Categories: string = "";
    Remark: string = "";
    Nationality: string = "";
    ResponseStatus: string = "";
    Birthday: string = "";
    FirstName: string = "";
    LastName: string = "";
}
